import React from "react";
import Modal from "react-bootstrap/Modal";
//UI
import { DangerButton, SuccessButton } from "../../../../ui/buttons/Button";
import { Checkbox, Input, SearchInput, Select  } from "../../../../ui/inputs/Input";
import TablaFormatoReporte from "./TablaFormatoReporte";
import TablaEnvioCorreo from "./TablaEnvioCorreo";

export default function ReportesNomina({ show, setShow, setTabla }) {
  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Reportes Personalizados de Conceptos</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: 300, overflowY: 'auto' }}> 
        <nav>
          <div className="nav nav-tabs mb-2" id="nav-tab" role="tablist">
            <button
              className="nav-link active"
              id="nav-formatoReporte-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-formatoReporte"
              type="button"
              role="tab"
              aria-controls="nav-formatoReporte"
              aria-selected="true"
            >
              Formato de Reporte
            </button>
            <button
              className="nav-link"
              id="nav-criteriosSeleccion-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-criteriosSeleccion"
              type="button"
              role="tab"
              aria-controls="nav-criteriosSeleccion"
              aria-selected="false"
            >
              Criterios de Selección
            </button>
            <button
              className="nav-link"
              id="nav-envioCorreo-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-envioCorreo"
              type="button"
              role="tab"
              aria-controls="nav-envioCorreo"
              aria-selected="false"
            >
              Envio de Correo
            </button>
          </div>
        </nav>
        <div className="tab-content" id="nav-tabContent">
          <div
            className="tab-pane fade show active"
            id="nav-formatoReporte"
            role="tabpanel"
            aria-labelledby="nav-formatoReporte-tab"
            tabindex="0"
          >
            <TablaFormatoReporte />
          </div>
          <div
            className="tab-pane fade"
            id="nav-criteriosSeleccion"
            role="tabpanel"
            aria-labelledby="nav-criteriosSeleccion-tab"
            tabindex="0"
          >
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Nº de Recibo:</span>
              <div className="col-3 m-0 p-0">
                <Input label = 'Desde:' />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input label = 'Hasta:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Cod. Integrante:</span>
              <div className="col-3 m-0 p-0">
                <SearchInput label = 'Desde:' />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <SearchInput label = 'Hasta:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Ced. Integrante:</span>
              <div className="col-3 m-0 p-0">
                <SearchInput label = 'Desde:' />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <SearchInput label = 'Hasta:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Cod. Concepto:</span>
              <div className="col-3 m-0 p-0">
                <SearchInput label = 'Desde:' />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <SearchInput label = 'Hasta:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <div className="col m-0 p-0">
                <SearchInput label = 'Cod. Mes Desde:' />
              </div>
              <div className="col m-0 p-0 pl-2">
                <SearchInput label = 'Cod. Mes Hasta:' />
              </div>
              <div className="col m-0 p-0 pl-2">
                <Input label = 'Año Desde:' />
              </div>
              <div className="col m-0 p-0 pl-2">
                <Input label = 'Año Hasta:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Período:</span>
              <div className="col-3 m-0 p-0">
                <Input label = 'Desde:' />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input label = 'Hasta:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-2 m-0 p-0 fw-bold">Cod. Banco:</span>
              <div className="col-3 m-0 p-0">
                <SearchInput label = 'Desde:' />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <SearchInput label = 'Hasta:' />
              </div>
              <div className="col-4 m-0 p-0 pl-2">
                <Select label = 'Ordenar Por:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Cod. Departamento:</span>
              <div className="col-3 m-0 p-0">
                <SearchInput label = 'Desde:' />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <SearchInput label = 'Hasta:' />
              </div>
            </div>
            <div className="col-6 m-0 mb-2 p-0">
              <Input label = 'Fecha para Calcular Años de Servicios:' type = 'date' />
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Rango de Edad:</span>
              <div className="col-3 m-0 p-0">
                <Input label = 'Desde:' type = 'date' />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input label = 'Hasta:' type = 'date' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
            <span className="col-6 m-0 p-0 fw-bold">Datos POA:</span>
              <div className="col-3 m-0 p-0">
                <Input label = 'Nº de Meses:' />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input label = 'Porcentaje:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Fecha de Aporte Patronal:</span>
              <div className="col-3 m-0 p-0">
                <Input label = 'Desde:' type = 'date' />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input label = 'Hasta:' type = 'date' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <div className="col-6 m-0 p-0 pr-2">
                <Input label = 'Fecha deposito Bancario:' type = 'date' />
              </div>
              <div className="col-6 m-0 p-0">
                <Input label = 'No. Planilla de Deposito Bancario:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <div className="col-4 m-0 p-0">
                <Input label = 'Fecha de Retención:' type = 'date' />
              </div>
              <div className="col-4 m-0 p-0 pl-2">
                <Input label = 'Agencia:' />
              </div>
              <div className="col-4 m-0 p-0 pl-2">
                <Input label = 'Rif. Empresa:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <div className="col-6 m-0 p-0">
                <Input label = 'Nom. Empresa:' />
              </div>
              <div className="col-6 m-0 p-0 pl-2">
                <Input label = 'Cuenta Ahorro. Hab:' />
              </div>
            </div>
            <div className="col-6 m-0 mb-2 p-0">
              <Input label = 'Titutlo de Reporte:' />
            </div>
            <div className="col-12 m-0 p-0 d-flex">
              <div className="col-8 m-0 p-0">
                <Checkbox label = 'Mostrar Período en el Reporte' />
              </div>
              <div className="col-4 m-0 p-0 pl-2">
                <Select label = 'Clase Concepto:' />
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="nav-envioCorreo"
            role="tabpanel"
            aria-labelledby="nav-envioCorreo-tab"
            tabindex="0"
          >
            <TablaEnvioCorreo />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton>Aceptar</SuccessButton>
        <DangerButton>Cancelar</DangerButton>
      </Modal.Footer>
    </Modal>
  );
}
